export default "__VITE_ASSET__eHejDzmB__"